import axios from 'axios';

export const httpConfig = {
    baseURL: process.env.REACT_APP_BASE_URL,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    }
}

const http = axios.create(httpConfig)

let refreshTokenEmAndamento = null;

export const AUTH_TOKEN_REFRESHED_EVENT = 'abralav:auth-token-refreshed';

export const adicionaTokenAuthorization = function (config) {
    const token = localStorage.getItem('Authorization')
    if(token && config.headers) {
        config.headers.Authorization = `Bearer ${token}`
    }
    return config;
}

export const trataErroRequest = function (error) {
    return Promise.reject(error);
}

export const trataResponseSucesso = function (response) {
    return response
}

export const encerraSessaoExpirada = function () {
    localStorage.removeItem('Authorization')
    localStorage.removeItem('RefreshToken')

}

export const notificaTokenRenovado = function () {
    window.dispatchEvent(new CustomEvent(AUTH_TOKEN_REFRESHED_EVENT))
}

export const renovaToken = async function () {
    const refresh = localStorage.getItem('RefreshToken')
    if (!refresh) {
        const erroSessaoExpirada = new Error('Sessão expirada. Faça login novamente.')
        erroSessaoExpirada.response = {
            status: 401,
            data: 'Sessão expirada. Faça login novamente.'
        }
        throw erroSessaoExpirada
    }

    const rs = await axios.post(`${process.env.REACT_APP_BASE_URL}/usuarios/atualiza-token`, { refreshToken: refresh });
    const accessToken = rs.headers.authorization
    const { refreshToken } = rs.data
    localStorage.setItem('Authorization', accessToken)
    localStorage.setItem('RefreshToken', refreshToken)
    notificaTokenRenovado()
    return accessToken
}

export const obtemTokenRenovado = function () {
    if(!refreshTokenEmAndamento) {
        refreshTokenEmAndamento = renovaToken()
            .finally(() => {
                refreshTokenEmAndamento = null
            })
    }

    return refreshTokenEmAndamento
}

export const criaTratadorErroAutenticacao = (httpClient) => async function (error) {
    const originalConfig = error.config;
    if (originalConfig.url !== "/usuarios/login" && error.response) {
        if (error.response.status === 401 && !originalConfig._retry) {
            originalConfig._retry = true;
            try {
                const accessToken = await obtemTokenRenovado()
                originalConfig.headers = originalConfig.headers || {}
                if(accessToken) {
                    originalConfig.headers.Authorization = `Bearer ${accessToken}`
                }
                return httpClient(originalConfig);
            } catch (_error) {
                encerraSessaoExpirada()
                return Promise.reject(_error);
            }
        }
    }
    return Promise.reject(error);
}

http.interceptors.request.use(adicionaTokenAuthorization, trataErroRequest);
http.interceptors.response.use(trataResponseSucesso, criaTratadorErroAutenticacao(http))

export default http
